import Config from 'config';
import AbstractService from './AbstractService';

export default class FlagService extends AbstractService {
	static removeRelease(releaseId) {
		return this.del(Config.endpoints.flagDetail.replace('{0}', releaseId));
	}

	static clear() {
		return this.del(Config.endpoints.flag);
	}
}
